import { loadEliminations } from './load-eliminations.js'
import { loadOneEntity } from './load-one-entity.js'

export async function loadDataStatements (context) {
  // console.log('loadDataStatements', context)
  const includedEntityIds = context.includedEntityIds
  if (!includedEntityIds) return
  if (includedEntityIds.length === 0) return

  const promises = []
  includedEntityIds.forEach(function (includedEntityId) {
    promises.push(loadOneEntity(includedEntityId, context))
  })
  promises.push(loadEliminations(context))

  const loadedData = await Promise.all(promises)
  // console.log('loadDataStatements loadedData', loadedData)

  return loadedData[0]
}
